'use strict'

const Logger = require('@gsm/logger')
const Policy = require('./access-policy/policy')

class Authorizer {

    constructor(policyJson) {
        this.policy = Policy.create(policyJson)
    }

    authorize(action, orn) {
        Logger.info(`Requested ${action} on ${orn}`)
        return this.canI(action, orn)
    }

    canI(action, orn) {
        return this.policy.allows(action, orn)
    }

}

module.exports = Authorizer



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/authorizer.js
// module id = 293
// module chunks = 51